import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  path?: string;
};

type Props = {
  en: string;
  ja: string;
  crumbs: Crumb[];
};

export default function PageHero({ en, ja, crumbs }: Props) {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950 pt-32 pb-16 md:pt-44 md:pb-24">
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Abstract%20dark%20minimal%20texture%20with%20soft%20flowing%20smoke%20and%20subtle%20golden%20light%20streaks%20on%20deep%20black%20background%2C%20elegant%20fine%20art%20photography%2C%20luxury%20brand%20aesthetic%2C%20calm%20and%20sophisticated&width=1920&height=600&seq=revra-page-hero&orientation=landscape')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/90" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
        <nav aria-label="breadcrumb" className="mb-6 flex flex-wrap items-center gap-2 text-xs md:text-sm">
          <Link to="/" className="text-background-400 transition-colors hover:text-accent-300">
            TOP
          </Link>
          {crumbs.map((crumb, index) => (
            <span key={crumb.label} className="flex items-center gap-2">
              <span className="text-background-600">/</span>
              {crumb.path && index !== crumbs.length - 1 ? (
                <Link
                  to={crumb.path}
                  className="text-background-400 transition-colors hover:text-accent-300"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-background-200">{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>
        <p className="font-body text-xs tracking-[0.4em] uppercase text-accent-300">{ja}</p>
        <h1 className="mt-4 font-display text-5xl md:text-6xl lg:text-7xl font-light tracking-[0.06em] text-background-50">
          {en}
        </h1>
        <span className="mt-8 block h-px w-24 bg-accent-500/70" />
      </div>
    </section>
  );
}